import React from 'react'
import BaseIcon from 'react-icon-base'
import { EColors } from 'app/constants/colors'

const Cross = ({ pathProps, ...props }) => (
  <BaseIcon width="12" height="13" viewBox="0 0 12 13" style={{ cursor: 'pointer' }} {...props}>
    <g stroke={EColors.GREY} strokeWidth=".95" fill="none" fillRule="evenodd">
      <path d="M.211 12.261 11.618.854M11.789 12.261.382.854" />
    </g>
  </BaseIcon>
)

export default Cross
